<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">Form First Assessment</div>
    <div class="box">
      <div class="p-20 pb-0">
        <div class="row">
          <div class="col-6">
            <a @click="
              openPage(
                '/memberData/detail?id=' +
                id_lead_member +
                '&id_lead=' +
                id_lead
              )
              " class="link-back"><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
          </div>
        </div>
      </div>
      <hr class="mb-0" />
      <div class="p-20 pt-0">
        <form @submit.prevent="submitForm">
          <div class="row mb-30">
            <div class="col-lg-6">
              <div class="font-bold mt-20" style="font-size: 18px;">Basic Information</div>
              <hr class="short-line left" />
              <hr>

              <!-- <b-row class="mb-20">
                <b-col sm="3">
                  <label>Member</label>
                </b-col>
                <b-col sm="9">
                  <div class="custom-search-select">
                    <model-select autocomplete="false" :options="optionsMember"
                      @searchchange="searchMemberWithoutBranch" class="border-bottom" placeholder="Select member"
                      name="member_id" v-model="addData.member_id"></model-select>
                  </div>
                </b-col>
              </b-row> -->

              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Personal Trainer</div>
                </b-col>
                <b-col sm="9">
                  <b-form-select :disabled="true" name="refferal_pt_id" v-model="addData.personal_trainer_id"
                    class="form-control border-bottom">
                    <option value="null">Please select</option>
                    <option v-for="item in itemsPT" :key="item.id" :value="item.id">{{ item.name }}</option>
                  </b-form-select>
                </b-col>
              </b-row>

              <div class="font-bold mt-20" style="font-size: 18px;">Primary Goals</div>
              <hr class="short-line left" />

              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Fat Loss Goal<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-input placeholder="Example: “Lose 5 kg”, “Reduce belly fat”" v-validate="'required'"
                    class="form-control border-bottom" v-model="addData.fat_loss_goal" name="fat_loss_goal"
                    type="text"></b-form-input>
                  <span class="error">{{ errors.first("fat_loss_goal") }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Body Comp Goal<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-input placeholder="Example: “Lower body fat %”, “Improve shape”" v-validate="'required'"
                    class="form-control border-bottom" v-model="addData.body_composition_goal"
                    name="body_composition_goal" type="text"></b-form-input>
                  <span class="error">{{ errors.first("body_composition_goal") }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Lifestyle Goal<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-input placeholder="Example: “Sleep better”, “Be more consistent”, “Exercise 3x/week”"
                    v-validate="'required'" class="form-control border-bottom" v-model="addData.lifestyle_goal"
                    name="lifestyle_goal" type="text"></b-form-input>
                  <span class="error">{{ errors.first("lifestyle_goal") }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Performance Goal<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-input placeholder="Example: “Better stamina”, “Stronger”, “Move better”"
                    v-validate="'required'" class="form-control border-bottom" v-model="addData.performance_goal"
                    name="performance_goal" type="text"></b-form-input>
                  <span class="error">{{ errors.first("performance_goal") }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Timeframe Expectation<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-validate="'required'" v-model="addData.timeframe_expectation_id"
                    id="longExercise" name="longExercise">
                    <template v-for="value in TIMEFRAME_EXPETATION">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <span class="error">{{ errors.first("timeframe_expectation_id") }}</span>
                </b-col>
              </b-row>

              <br>
              <div class="font-bold mt-20" style="font-size: 18px;">Body Composition Baseline</div>
              <hr class="short-line left" />
              <hr>

              <b-row class="mb-20">
                <b-col sm="12">
                  <div class="mb-2">Upload the Last Visbody/Inbody/Anovator measurement</div>
                </b-col>
                <b-col sm="9">
                  <div class="upload-container">
                    <label class="upload-box" id="drop-area">
                      <input type="file" id="fileElem" hidden accept="image/jpeg,image/png,image/jpg"
                        @change="visbodyImagePreview" />

                      <div class="upload-content">
                        <div class="icon">
                          ☁️
                        </div>
                        <h5>Browse Files</h5>
                        <p>Drag and drop files here</p>
                      </div>
                    </label>

                    <small class="note">
                      Make sure it shows Body Height, Body Weight, Body Fat, Body Fat %, Muscle %, Visceral Fat <br>
                      Format: jpg, jpeg, png | Max Size: 1MB
                    </small>
                    <div class="card" v-if="addData.visbody_photo">
                      <div class="card-body d-flex align-items-center justify-content-start gap-2">
                        <img style="max-width: 10%;" :src="addData.visbody_photo"
                          class="rounded float-start img-responsive w-100" />
                        <span style="padding-left: 10px;" class="font-bold ps-5">Visbody Photo</span>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Waist Circumference?<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-input placeholder="e.g.,23" v-validate="'required'" class="form-control border-bottom"
                    v-model="addData.waist_circumference" name="waist_circumference" type="number"></b-form-input>
                  <span class="error">{{ errors.first("waist_circumference") }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Hip circumference?<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-input placeholder="e.g.,23" v-validate="'required'" class="form-control border-bottom"
                    v-model="addData.hip_circumference" name="hip_circumference" type="number"></b-form-input>
                  <span class="error">{{ errors.first("hip_circumference") }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="12">
                  <div class="mb-2">Progress FRONT photo<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <div class="upload-container">
                    <label class="upload-box" id="drop-area">
                      <input type="file" id="fileElem" hidden accept="image/jpeg,image/png,image/jpg"
                        @change="frontPhotoPreview" />

                      <div class="upload-content">
                        <div class="icon">
                          ☁️
                        </div>
                        <h5>Browse Files</h5>
                        <p>Drag and drop files here</p>
                      </div>
                    </label>

                    <small class="note">
                      Format: jpg, jpeg, png | Max Size: 1MB
                    </small>

                    <div class="card" v-if="addData.progress_front_photo">
                      <div class="card-body d-flex align-items-center justify-content-start gap-2">
                        <img style="max-width: 10%;" :src="addData.progress_front_photo"
                          class="rounded float-start img-responsive w-100" />
                        <span style="padding-left: 10px;" class="font-bold ps-5">Front Photo</span>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="12">
                  <div class="mb-2">Progress SIDE LEFT photo<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <div class="upload-container">
                    <label class="upload-box" id="drop-area">
                      <input type="file" id="fileElem" hidden accept="image/jpeg,image/png,image/jpg"
                        @change="sideLeftPhotoPreview" />

                      <div class="upload-content">
                        <div class="icon">
                          ☁️
                        </div>
                        <h5>Browse Files</h5>
                        <p>Drag and drop files here</p>
                      </div>
                    </label>

                    <small class="note">
                      Format: jpg, jpeg, png | Max Size: 1MB
                    </small>

                    <div class="card" v-if="addData.progress_side_left_photo">
                      <div class="card-body d-flex align-items-center justify-content-start gap-2">
                        <img style="max-width: 10%;" :src="addData.progress_side_left_photo"
                          class="rounded float-start img-responsive w-100" />
                        <span style="padding-left: 10px;" class="font-bold ps-5">Side Left Photo</span>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="12">
                  <div class="mb-2">Progress SIDE Right photo<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <div class="upload-container">
                    <label class="upload-box" id="drop-area">
                      <input type="file" id="fileElem" hidden accept="image/jpeg,image/png,image/jpg"
                        @change="sideRightPhotoPreview" />

                      <div class="upload-content">
                        <div class="icon">
                          ☁️
                        </div>
                        <h5>Browse Files</h5>
                        <p>Drag and drop files here</p>
                      </div>
                    </label>

                    <small class="note">Format: jpg, jpeg, png | Max Size: 1MB
                    </small>
                    <div class="card" v-if="addData.progress_side_right_photo">
                      <div class="card-body d-flex align-items-center justify-content-start gap-2">
                        <img style="max-width: 10%;" :src="addData.progress_side_right_photo"
                          class="rounded float-start img-responsive w-100" />
                        <span style="padding-left: 10px;" class="font-bold ps-5">Side Right Photo</span>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="12">
                  <div class="mb-2">Progress BACK photo<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <div class="upload-container">
                    <label class="upload-box" id="drop-area">
                      <input type="file" id="fileElem" hidden accept="image/jpeg,image/png,image/jpg"
                        @change="sideBackPhotoPreview" />

                      <div class="upload-content">
                        <div class="icon">
                          ☁️
                        </div>
                        <h5>Browse Files</h5>
                        <p>Drag and drop files here</p>
                      </div>
                    </label>

                    <small class="note">
                      Format: jpg, jpeg, png | Max Size: 1MB
                    </small>
                    <div class="card" v-if="addData.progress_side_back_photo">
                      <div class="card-body d-flex align-items-center justify-content-start gap-2">
                        <img style="max-width: 10%;" :src="addData.progress_side_back_photo"
                          class="rounded float-start img-responsive w-100" />
                        <span style="padding-left: 10px;" class="font-bold ps-5">Side Back Photo</span>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>

              <br>
              <div class="font-bold mt-20" style="font-size: 18px;">Movement Review</div>
              <hr class="short-line left" />
              <hr>

              <!-- Squat pattern -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Squat pattern<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-validate="'required'" v-model="addData.squat_pattern" id="squat_pattern"
                    name="squat_pattern">
                    <template v-for="value in ONE_CHOICES">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <span class="error">{{ errors.first("squat_pattern") }}</span>
                </b-col>
              </b-row>

              <!-- Remarks -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.squat_pattern_remarks"
                    name="squat_pattern_remarks" type="text"></b-form-input>
                </b-col>
              </b-row>

              <!-- Hinge pattern -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Hinge pattern<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-validate="'required'" v-model="addData.hinge_pattern" id="hinge_pattern"
                    name="hinge_pattern">
                    <template v-for="value in ONE_CHOICES">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <span class="error">{{ errors.first("hinge_pattern") }}</span>
                </b-col>
              </b-row>

              <!-- Remarks -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.hinge_pattern_remarks"
                    name="hinge_pattern_remarks" type="text"></b-form-input>
                </b-col>
              </b-row>

              <!-- Split stance control -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Split Stance Control<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-validate="'required'" v-model="addData.split_stance_control"
                    id="split_stance_control" name="split_stance_control">
                    <template v-for="value in ONE_CHOICES">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <span class="error">{{ errors.first("split_stance_control") }}</span>
                </b-col>
              </b-row>

              <!-- Remarks -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.split_stance_control_remarks"
                    name="split_stance_control_remarks" type="text"></b-form-input>
                </b-col>
              </b-row>

              <!-- Push pattern -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Push pattern<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-validate="'required'" v-model="addData.push_pattern" id="push_pattern"
                    name="push_pattern">
                    <template v-for="value in ONE_CHOICES">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <span class="error">{{ errors.first("push_pattern") }}</span>
                </b-col>
              </b-row>

              <!-- Remarks -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.push_pattern_remarks"
                    name="push_pattern_remarks" type="text"></b-form-input>
                </b-col>
              </b-row>

              <!-- Pull pattern -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Pull pattern<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-validate="'required'" v-model="addData.pull_pattern" id="pull_pattern"
                    name="pull_pattern">
                    <template v-for="value in ONE_CHOICES">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <span class="error">{{ errors.first("pull_pattern") }}</span>
                </b-col>
              </b-row>

              <!-- Remarks -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.pull_pattern_remarks"
                    name="pull_pattern_remarks" type="text"></b-form-input>
                </b-col>
              </b-row>

              <!-- Balance -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Balance<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-validate="'required'" v-model="addData.balance" id="balance" name="balance">
                    <template v-for="value in ONE_CHOICES">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <span class="error">{{ errors.first("balance") }}</span>
                </b-col>
              </b-row>

              <!-- Remarks -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.balance_remarks"
                    name="balance_remarks" type="text"></b-form-input>
                </b-col>
              </b-row>

              <!-- Coordination -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Coordination<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-validate="'required'" v-model="addData.coordination" id="coordination"
                    name="coordination">
                    <template v-for="value in ONE_CHOICES">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <span class="error">{{ errors.first("coordination") }}</span>
                </b-col>
              </b-row>

              <!-- Remarks -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.coordination_remarks"
                    name="coordination_remarks" type="text"></b-form-input>
                </b-col>
              </b-row>

              <!-- Gait / locomotion -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Gait / locomotion<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-validate="'required'" v-model="addData.gait_locomotion" id="gait_locomotion"
                    name="gait_locomotion">
                    <template v-for="value in ONE_CHOICES">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <span class="error">{{ errors.first("gait_locomotion") }}</span>
                </b-col>
              </b-row>

              <!-- Remarks -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.gait_locomotion_remarks"
                    name="gait_locomotion_remarks" type="text"></b-form-input>
                </b-col>
              </b-row>

              <!-- Rotation control -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Rotation control<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-validate="'required'" v-model="addData.rotation_control" id="rotation_control"
                    name="rotation_control">
                    <template v-for="value in ONE_CHOICES">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <span class="error">{{ errors.first("rotation_control") }}</span>
                </b-col>
              </b-row>

              <!-- Remarks -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.rotation_control_remarks"
                    name="rotation_control_remarks" type="text"></b-form-input>
                </b-col>
              </b-row>

              <!-- General posture -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">General posture<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-validate="'required'" v-model="addData.general_posture" id="general_posture"
                    name="general_posture">
                    <template v-for="value in ONE_CHOICES">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <span class="error">{{ errors.first("general_posture") }}</span>
                </b-col>
              </b-row>

              <!-- Remarks -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.general_posture_remarks"
                    name="general_posture_remarks" type="text"></b-form-input>
                </b-col>
              </b-row>

              <br>
              <div class="font-bold mt-20" style="font-size: 18px;">Strength and Work Capacity</div>
              <hr class="short-line left" />
              <hr>

              <!-- Conditioning baseline?  -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Conditioning baseline?<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-input v-validate="'required'" class="form-control border-bottom"
                    v-model="addData.conditioning_baseline" name="conditioning_baseline" type="text"></b-form-input>
                  <span class="error">{{ errors.first("conditioning_baseline") }}</span>
                </b-col>
              </b-row>

              <!-- Push baseline?  -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Push baseline?<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-input v-validate="'required'" class="form-control border-bottom"
                    v-model="addData.push_baseline" name="push_baseline" type="text"></b-form-input>
                  <span class="error">{{ errors.first("push_baseline") }}</span>
                </b-col>
              </b-row>

              <!-- Pull baseline? -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Pull baseline?<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-input v-validate="'required'" class="form-control border-bottom"
                    v-model="addData.pull_baseline" name="pull_baseline" type="text"></b-form-input>
                  <span class="error">{{ errors.first("pull_baseline") }}</span>
                </b-col>
              </b-row>

              <!-- Notes? -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Notes<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-input v-validate="'required'" class="form-control border-bottom" v-model="addData.notes"
                    name="notes" type="text"></b-form-input>
                  <span class="error">{{ errors.first("notes") }}</span>
                </b-col>
              </b-row>

              <br>
              <div class="font-bold mt-20" style="font-size: 18px;">Nutrition Review</div>
              <hr class="short-line left" />
              <hr>

              <!-- Meal Frequency -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Meal Frequency<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-validate="'required'" v-model="addData.meal_frequency_id" id="meal_frequency_id"
                    name="meal_frequency_id">
                    <template v-for="value in ONE_CHOICES">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <span class="error">{{ errors.first("meal_frequency_id") }}</span>
                </b-col>
              </b-row>

              <!-- Remarks -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.meal_remarks" name="meal_remarks"
                    type="text"></b-form-input>
                </b-col>
              </b-row>

              <!-- Protein quality / intake -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Protein quality / intake<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-validate="'required'" v-model="addData.protein_quality_id"
                    id="protein_quality_id" name="protein_quality_id">
                    <template v-for="value in ONE_CHOICES">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <span class="error">{{ errors.first("protein_quality_id") }}</span>
                </b-col>
              </b-row>

              <!-- Remarks -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.protein_remarks"
                    name="protein_remarks" type="text"></b-form-input>
                </b-col>
              </b-row>

              <!-- Hydration -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Hydration<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-validate="'required'" v-model="addData.hydration_id" id="hydration_id"
                    name="hydration_id">
                    <template v-for="value in ONE_CHOICES">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <span class="error">{{ errors.first("hydration_id") }}</span>
                </b-col>
              </b-row>

              <!-- Remarks -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.hydration_remarks"
                    name="hydration_remarks" type="text"></b-form-input>
                </b-col>
              </b-row>

              <!-- Snacking habits -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Snacking habits<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-validate="'required'" v-model="addData.snacking_habits_id"
                    id="snacking_habits_id" name="snacking_habits_id">
                    <template v-for="value in ONE_CHOICES">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <span class="error">{{ errors.first("snacking_habits_id") }}</span>
                </b-col>
              </b-row>

              <!-- Remarks -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.snacking_habits_remarks"
                    name="snacking_habits_remarks" type="text"></b-form-input>
                </b-col>
              </b-row>

              <!-- Weekend Intake -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Weekend Intake<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-validate="'required'" v-model="addData.weekend_Intake_id" id="weekend_Intake_id"
                    name="weekend_Intake_id">
                    <template v-for="value in ONE_CHOICES">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <span class="error">{{ errors.first("weekend_Intake_id") }}</span>
                </b-col>
              </b-row>

              <!-- Remarks -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.weekend_Intake_remarks"
                    name="weekend_Intake_remarks" type="text"></b-form-input>
                </b-col>
              </b-row>

              <!-- Eating out frequency -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Eating out frequency<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-validate="'required'" v-model="addData.eating_out_frequency_id"
                    id="eating_out_frequency_id" name="eating_out_frequency_id">
                    <template v-for="value in ONE_CHOICES">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <span class="error">{{ errors.first("eating_out_frequency_id") }}</span>
                </b-col>
              </b-row>

              <!-- Remarks -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.eating_out_frequency_remarks"
                    name="eating_out_frequency_remarks" type="text"></b-form-input>
                </b-col>
              </b-row>

              <!-- Diet history -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Diet history<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-input v-validate="'required'" class="form-control border-bottom"
                    v-model="addData.diet_history" name="diet_history" type="text"></b-form-input>
                  <span class="error">{{ errors.first("diet_history") }}</span>
                </b-col>
              </b-row>

              <!-- Willing to track intake -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Willing to track intake<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-validate="'required'" v-model="addData.willing_to_track_intake_id"
                    id="willing_to_track_intake_id" name="willing_to_track_intake_id">
                    <template v-for="value in ONE_CHOICES">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <span class="error">{{ errors.first("willing_to_track_intake_id") }}</span>
                </b-col>
              </b-row>

              <!-- Remarks -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.willing_to_track_intake_remarks"
                    name="willing_to_track_intake_remarks" type="text"></b-form-input>
                </b-col>
              </b-row>

              <!-- Main nutrition obstacles -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Main nutrition obstacles<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-input v-validate="'required'" class="form-control border-bottom"
                    v-model="addData.main_nutrition_obstacles" name="main_nutrition_obstacles"
                    type="text"></b-form-input>
                  <span class="error">{{ errors.first("main_nutrition_obstacles") }}</span>
                </b-col>
              </b-row>

            </div>

            <!-- Col 2 -->
            <div class="col-lg-6">
              <div class="font-bold mt-20" style="font-size: 18px;">Lifestyle Review</div>
              <hr class="short-line left" />
              <hr>

              <!-- Sleep Quality? -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Sleep Quality?<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-validate="'required'" v-model="addData.sleep_quality_id" id="sleep_quality_id"
                    name="sleep_quality_id">
                    <template v-for="value in ONE_CHOICES">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <span class="error">{{ errors.first("sleep_quality_id") }}</span>
                </b-col>
              </b-row>

              <!-- Remarks -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.sleep_quality_remarks"
                    name="sleep_quality_remarks" type="text"></b-form-input>
                </b-col>
              </b-row>

              <!-- Stress Level? -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Stress Level?<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-model="addData.stress_level_id" id="stress_level_id" name="stress_level_id">
                    <template v-for="value in ORDINAL_SCALE">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                </b-col>
              </b-row>

              <!-- Remarks -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.stress_level_remarks"
                    name="stress_level_remarks" type="text"></b-form-input>
                </b-col>
              </b-row>

              <!-- Work Schedule? -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Work Schedule?<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-model="addData.work_schedule_id" id="work_schedule_id" name="work_schedule_id">
                    <template v-for="value in WORK_SCHEDULE">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                </b-col>
              </b-row>

              <!-- Remarks -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.work_schedule_remarks"
                    name="work_schedule_remarks" type="text"></b-form-input>
                </b-col>
              </b-row>

              <!-- Daily Excercise? -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Daily Exercise?<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-model="addData.daily_excercise_id" id="daily_excercise_id"
                    name="daily_excercise_id">
                    <template v-for="value in EATING_OUT_FREQ">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                </b-col>
              </b-row>

              <!-- Remarks -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.daily_excercise_remarks"
                    name="daily_excercise_remarks" type="text"></b-form-input>
                </b-col>
              </b-row>

              <!-- Travel Demands? -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Travel Demands?<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-validate="'required'" v-model="addData.travel_demands_id" id="travel_demands_id"
                    name="travel_demands_id">
                    <template v-for="value in ONE_CHOICES">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <span class="error">{{ errors.first("travel_demands_id") }}</span>
                </b-col>
              </b-row>

              <!-- Remarks -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.travel_demands_remarks"
                    name="travel_demands_remarks" type="text"></b-form-input>
                </b-col>
              </b-row>

              <!-- Family / Social Barriers -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Family / Social Barriers<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-validate="'required'" v-model="addData.family_or_social_barriers"
                    id="family_or_social_barriers" name="family_or_social_barriers">
                    <template v-for="value in ONE_CHOICES">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <span class="error">{{ errors.first("family_or_social_barriers") }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.family_or_social_barriers_remarks"
                    name="family_or_social_barriers_remarks" type="text"></b-form-input>
                </b-col>
              </b-row>

              <!-- Recovery Habits -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Recovery Habits<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-validate="'required'" v-model="addData.recovery_habits" id="recovery_habits"
                    name="recovery_habits">
                    <template v-for="value in ONE_CHOICES">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <span class="error">{{ errors.first("recovery_habits") }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.recovery_habits_remarks"
                    name="recovery_habits_remarks" type="text"></b-form-input>
                  <span class="error">{{ errors.first("recovery_habits_remarks") }}</span>
                </b-col>
              </b-row>

              <br>
              <div class="font-bold mt-20" style="font-size: 18px;">Mindset and Accountability</div>
              <hr class="short-line left" />
              <hr>

              <!-- Motivation Level -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Motivation Level<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-model="addData.motivation_level_id" id="motivation_level_id"
                    name="motivation_level_id">
                    <template v-for="value in ONE_CHOICES">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                </b-col>
              </b-row>

              <!-- Remarks -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.motivation_level_remarks"
                    name="motivation_level_remarks" type="text"></b-form-input>
                </b-col>
              </b-row>

              <!-- Confidence Level -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Confidence Level<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-model="addData.confidence_level_id" id="confidence_level_id"
                    name="confidence_level_id">
                    <template v-for="value in ONE_CHOICES">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                </b-col>
              </b-row>

              <!-- Remarks -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.confidence_level_remarks"
                    name="confidence_level_remarks" type="text"></b-form-input>
                </b-col>
              </b-row>

              <!-- Consistency Level -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Consistency Level<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-model="addData.consistency_level_id" id="consistency_level_id"
                    name="consistency_level_id">
                    <template v-for="value in ONE_CHOICES">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                </b-col>
              </b-row>

              <!-- Remarks -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.consistency_level_remarks"
                    name="consistency_level_remarks" type="text"></b-form-input>
                </b-col>
              </b-row>

              <!-- Common Barriers -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Common Barriers<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-input v-validate="'required'" class="form-control border-bottom"
                    v-model="addData.common_barriers" name="common_barriers" type="text"></b-form-input>
                  <span class="error">{{ errors.first("common_barriers") }}</span>
                </b-col>
              </b-row>

              <!-- Self-Sabotage Patterns -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Self-Sabotage Patterns<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-input v-validate="'required'" class="form-control border-bottom"
                    v-model="addData.self_sabotage_patterns" name="self_sabotage_patterns" type="text"></b-form-input>
                  <span class="error">{{ errors.first("self_sabotage_patterns") }}</span>
                </b-col>
              </b-row>

              <!-- Readliness to Change -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Readiness to Change<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-model="addData.readliness_to_change_id" id="readliness_to_change_id"
                    name="readliness_to_change_id">
                    <template v-for="value in ONE_CHOICES">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                </b-col>
              </b-row>

              <!-- Remarks -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.readliness_to_change_remarks"
                    name="readliness_to_change_remarks" type="text"></b-form-input>
                </b-col>
              </b-row>

              <!-- Coach Observations -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Coach Observations<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-input v-validate="'required'" class="form-control border-bottom"
                    v-model="addData.coach_observations" name="coach_observations" type="text"></b-form-input>
                  <span class="error">{{ errors.first("coach_observations") }}</span>
                </b-col>
              </b-row>

              <br>
              <div class="font-bold mt-20" style="font-size: 18px;">Coach Summary</div>
              <hr class="short-line left" />
              <hr>

              <!-- Starting Level -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Starting Level<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-model="addData.starting_level_id" id="starting_level_id"
                    name="starting_level_id">
                    <template v-for="value in ONE_CHOICES">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                </b-col>
              </b-row>

              <!-- Remarks -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="addData.starting_level_remarks"
                    name="starting_level_remarks" type="text"></b-form-input>
                </b-col>
              </b-row>

              <!-- Main Limitations -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Main Limitations<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-input v-validate="'required'" class="form-control border-bottom"
                    v-model="addData.main_limitations" name="main_limitations" type="text"></b-form-input>
                  <span class="error">{{ errors.first("main_limitations") }}</span>
                </b-col>
              </b-row>

              <!-- Main Strengths -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Main Strengths<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-input v-validate="'required'" class="form-control border-bottom"
                    v-model="addData.main_strengths" name="main_strengths" type="text"></b-form-input>
                  <span class="error">{{ errors.first("main_strengths") }}</span>
                </b-col>
              </b-row>

              <!-- First 3 Priorities -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>First 3 Priorities<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <div class="table-responsive">
                    <table class="table custom-table align-middle">
                      <thead>
                        <tr>
                          <th style="width: 80px;"></th>
                          <th class="text-center">Priority</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td class="index-cell">1</td>
                          <td>
                            <input v-model="addData.priorities_1" v-validate="'required'" type="text"
                              class="form-control border-0 shadow-none" placeholder="Enter Priority">
                          </td>
                        </tr>
                        <tr>
                          <td class="index-cell">2</td>
                          <td>
                            <input v-model="addData.priorities_2" v-validate="'required'" type="text"
                              class="form-control border-0 shadow-none" placeholder="Enter Priority">
                          </td>
                        </tr>
                        <tr>
                          <td class="index-cell">3</td>
                          <td>
                            <input v-model="addData.priorities_3" v-validate="'required'" type="text"
                              class="form-control border-0 shadow-none" placeholder="Enter Priority">
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </b-col>
              </b-row>

              <br>
              <div class="font-bold mt-20" style="font-size: 18px;">Blood Test</div>
              <hr class="short-line left" />
              <hr>

              <!-- Fasting Blood Sugar -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Fasting Blood Sugar</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input placeholder="e.g., 23" class="form-control border-bottom"
                    v-model="addData.fasting_blood_sugar" name="fasting_blood_sugar" type="number"></b-form-input>
                  <small class="note">
                    Preference: Under 87
                  </small>
                </b-col>
              </b-row>

              <!-- Triglycerides -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Triglycerides</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input placeholder="e.g., 23" class="form-control border-bottom"
                    v-model="addData.triglycerides" name="triglycerides" type="number"></b-form-input>
                  <small class="note">
                    Preference: Under 140
                  </small>
                </b-col>
              </b-row>

              <!-- Cholesterol -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Cholesterol</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input placeholder="e.g., 23" class="form-control border-bottom" v-model="addData.cholesterol"
                    name="cholesterol" type="number"></b-form-input>
                  <small class="note">
                    Preference: Under 200
                  </small>
                </b-col>
              </b-row>

              <!-- LDL -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>LDL</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input placeholder="e.g., 23" class="form-control border-bottom" v-model="addData.ldl"
                    name="ldl" type="number"></b-form-input>
                  <small class="note">
                    Preference: Under 100
                  </small>
                </b-col>
              </b-row>

              <!-- HDL -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>HDL</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input placeholder="e.g., 23" class="form-control border-bottom" v-model="addData.hdl"
                    name="hdl" type="number"></b-form-input>
                </b-col>
              </b-row>


              <!-- SGPT (Pancreas Function) -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>SGPT (Liver Function)</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input placeholder="e.g., 23" class="form-control border-bottom" v-model="addData.sgpt"
                    name="sgpt" type="number"></b-form-input>
                  <small class="note">
                    Preference: Under 50
                  </small>
                </b-col>
              </b-row>

              <!-- Additional Notes -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Additional Notes</div>
                </b-col>
                <b-col sm="9">
                  <textarea class="form-control border-bottom" name="additional_notes"
                    v-model="addData.additional_notes" id="additional_notes" cols="30"></textarea>
                </b-col>
              </b-row>

              <div class="container py-5">
                <div class="p-4 card-custom">

                  <h3 class="text-center fw-bold mb-4">NUTRITION ADVICE</h3>

                  <p class="fw-semibold text-uppercase text-center mb-4">
                    If your blood test shows high on blood sugar, triglycerides, and cholesterol
                  </p>

                  <!-- DOs -->
                  <h5 class="section-title mb-3">DOs:</h5>

                  <div class="mb-4">
                    <h6 class="fw-bold">1. Recommended Good Fat:</h6>
                    <ul>
                      <li>Avocado</li>
                      <li>Egg</li>
                      <li>Nuts</li>
                      <li>Dark Chocolate</li>
                    </ul>
                    <p class="note">
                      Good fat helps to stabilize hormones and decrease inflammation to the body
                    </p>
                  </div>

                  <div class="mb-4">
                    <h6 class="fw-bold">2. Optimize Gut Function:</h6>
                    <ul>
                      <li>Consume gut drinks: Probiotic, Apple Cider Vinegar, Glutamin, Lemon</li>
                    </ul>
                    <p class="note">
                      Help absorb maximum nutrition, support recovery, so not only depends on medication
                    </p>
                  </div>

                  <div class="mb-4">
                    <h6 class="fw-bold">3. Reduce Inflammation and Stress on the Body:</h6>
                    <ul>
                      <li>Consume support with vitamin: Vit D, Vit C, and Fish Oil</li>
                      <li>(Optional) Consume Berberine</li>
                    </ul>
                    <p class="note">
                      The less stress and inflammation the body = faster recovery
                    </p>
                  </div>

                  <!-- DON'Ts -->
                  <h5 class="section-title mt-4 mb-3">DON'Ts:</h5>

                  <ol>
                    <li>Consume processed food and high sugar drinks (soda, boba, alcohol, high sugar coffee)</li>
                    <li>Drink too much cold pressed juice</li>
                    <li>Too much anaerobic exercise</li>
                    <li>Lack of sleep</li>
                  </ol>

                  <!-- Additional Note -->
                  <h5 class="section-title mt-4 mb-3">Additional Note:</h5>

                  <p class="fw-bold">SGPT (Liver Function)</p>
                  <ul>
                    <li>Impact from daily habit/lifestyle</li>
                    <li>If liver not working well, the blood sugar can increase and cause insulin resistant</li>
                    <li>If absorb nutrition from liver not optimal, make cholesterol in the blood become high</li>
                  </ul>

                </div>
              </div>

            </div>
          </div>
          <hr>
          <div class="text-right">
            <button type="submit" class="btn-primary">Submit</button>
          </div>
        </form>
      </div>
    </div>

    <div v-if="loadingActive == true" class="loading-container">
      <div class="wrap-screen w-100 h-100">
        <img :src="`/svg-loaders/oval.svg`" width="60" alt="">
        <div class="title-loading color-white">Loading...</div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from "axios";
import { Auth } from "@/api";
import moment from "moment";
import { ModelSelect } from "vue-search-select";
import Mixin from '../../mixins/memberMixin'

export default {
  name: "addMemberDiary",
  components: {
    ModelSelect,
  },
  mixins: [Mixin],
  data: function () {
    return {
      loadingActive: false,
      itemsPT: [],
      optionsMember: [{ value: null, text: 'Please select' }],
      id_lead_member: null,
      id_lead: null,
      addData: {
        member_id: null,
        personal_trainer_id: null,
        fat_loss_goal: '',
        body_composition_goal: '',
        lifestyle_goal: '',
        performance_goal: '',
        timeframe_expectation_id: 0,
        visbody_photo: '',
        waist_circumference: 0,
        hip_circumference: 0,
        progress_front_photo: '',
        progress_side_left_photo: '',
        progress_side_right_photo: '',
        progress_side_back_photo: '',
        squat_pattern: null,
        hinge_pattern: null,
        split_stance_control: null,
        push_pattern: null,
        pull_pattern: null,
        balance: null,
        coordination: null,
        gait_locomotion: null,
        rotation_control: null,
        general_posture: null,
        squat_pattern_remarks: '',
        hinge_pattern_remarks: '',
        split_stance_control_remarks: '',
        push_pattern_remarks: '',
        pull_pattern_remarks: '',
        balance_remarks: '',
        coordination_remarks: '',
        gait_locomotion_remarks: '',
        rotation_control_remarks: '',
        general_posture_remarks: '',
        carry_tolerance: '',
        conditioning_baseline: '',
        push_baseline: '',
        pull_baseline: '',
        notes: '',
        meal_frequency_id: 0,
        meal_remarks: '',
        protein_quality_id: 0,
        protein_remarks: '',
        hydration_id: 0,
        hydration_remarks: '',
        snacking_habits_id: 0,
        snacking_habits_remarks: '',
        weekend_Intake_id: 0,
        weekend_Intake_remarks: '',
        eating_out_frequency_id: 0,
        eating_out_frequency_remarks: '',
        diet_history: '',
        willing_to_track_intake_id: 0,
        willing_to_track_intake_remarks: '',
        main_nutrition_obstacles: '',
        sleep_quality_id: 0,
        sleep_quality_remarks: '',
        stress_level_id: 0,
        stress_level_remarks: '',
        work_schedule_id: 0,
        work_schedule_remarks: '',
        daily_excercise_id: 0,
        daily_excercise_remarks: '',
        travel_demands_id: 0,
        travel_demands_remarks: '',
        family_or_social_barriers: null,
        family_or_social_barriers_remarks: '',
        recovery_habits: null,
        recovery_habits_remarks: '',
        motivation_level_id: 0,
        motivation_level_remarks: '',
        confidence_level_id: 0,
        confidence_level_remarks: '',
        consistency_level_id: 0,
        consistency_level_remarks: '',
        common_barriers: '',
        self_sabotage_patterns: '',
        readliness_to_change_id: 0,
        readliness_to_change_remarks: '',
        coach_observations: '',
        starting_level_id: 0,
        starting_level_remarks: '',
        main_limitations: '',
        main_strengths: '',
        priorities_1: '',
        priorities_2: '',
        priorities_3: '',
        fasting_blood_sugar: 0,
        triglycerides: 0,
        cholesterol: 0,
        ldl: 0,
        hdl: 0,
        sgpt: 0,
        additional_notes: '',
      },
      TIMEFRAME_EXPETATION: [],
      RATING_SCALE: [],
      MEAL_FREQUENCY: [],
      SNACKING_HABITS: [],
      WEEKEND_INTAKE: [],
      EATING_OUT_FREQ: [],
      WILLING_TO_TRACK: [],
      ORDINAL_SCALE: [],
      WORK_SCHEDULE: [],
      CONSISTENCY_LEVEL: [],
      visbodyPhotoPreview: null,
      visbodyPhotoPreview2: null,
      progressFrontPhotoPreview: null,
      progressSideLeftPhotoPreview: null,
      progressSideRightPhotoPreview: null,
      progressSideBackPhotoPreview: null,
    };
  },
  methods: {
    visbodyImagePreview: function (event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = e => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.visbodyPhotoPreview = e.target.result;

          // for upload not base64
          this.visbodyPhotoPreview2 = input.files[0];

          this.onUploadImage();
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
    frontPhotoPreview: function (event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = e => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          console.log(e.target.result)
          // for upload not base64
          this.progressFrontPhotoPreview = input.files[0];

          this.onUploadImageProgress(1);
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
    sideLeftPhotoPreview: function (event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = e => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          console.log(e.target.result)
          // for upload not base64
          this.progressSideLeftPhotoPreview = input.files[0];

          this.onUploadImageProgress(2);
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
    sideRightPhotoPreview: function (event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = e => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          console.log(e.target.result)
          // for upload not base64
          this.progressSideRightPhotoPreview = input.files[0];

          this.onUploadImageProgress(3);
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
    sideBackPhotoPreview: function (event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = e => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          console.log(e.target.result)
          // for upload not base64
          this.progressSideBackPhotoPreview = input.files[0];

          this.onUploadImageProgress(4);
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
    openPage(event) {
      this.$router.push(event)
    },
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          // confirm
          this.$swal
            .fire({
              title: "Are you sure?",
              text: "You won't be able to revert this!",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
              confirmButtonText: "Yes, save it!",
            })
            .then((result) => {
              if (result.value) {
                this.loadingActive = true
                axios.put("crm/v1/assessment/first_assessment/" + this.$route.query.xid, this.addData)
                  .then((response) => {
                    console.log('response', response)
                    this.loadingActive = false
                    this.$swal.fire(
                      "Saved!",
                      "Data has been saved.",
                      "success"
                    );

                    this.reloadData();
                  }).catch(error => {
                    this.loadingActive = false
                    console.log('error', error)
                    this.$toast.success('cant saved data!', 'Error', {
                      position: 'topCenter',
                      icon: 'icon-envelope',
                      progressBarColor: 'rgb(0, 255, 184)',
                      theme: 'dark',
                      backgroundColor: '#565c70',
                      messageColor: '#fff'
                    })
                  })
              }
            });
        } else {
          this.$toast.success("please fill in required fields!", "Error", {
            position: "topCenter",
            icon: "icon-envelope",
            progressBarColor: "rgb(0, 255, 184)",
            theme: "dark",
            backgroundColor: "#565c70",
            messageColor: "#fff",
          });
        }
      });
    },
    onUploadImageProgress(event) {
      this.loadingActive = true
      const formDataS3 = new FormData();

      if (event == 1) {
        formDataS3.append("file", this.progressFrontPhotoPreview);
      } else if (event == 2) {
        formDataS3.append("file", this.progressSideLeftPhotoPreview);
      } else if (event == 3) {
        formDataS3.append("file", this.progressSideRightPhotoPreview);
      } else if (event == 4) {
        formDataS3.append("file", this.progressSideBackPhotoPreview);
      }

      formDataS3.append("prefix", `ASSESMENT-${this.$route.query.id}`);
      axios.post("https://digmsix.paradigmfitnessindonesia.com/s3/storage/upload", formDataS3)
        .then(resp => {
          console.log("Photo uploaded to s3", resp);
          let updateBody = {}

          if (event == 1) {
            updateBody = { progress_front_photo: resp.data.data.location }
          } else if (event == 2) {
            updateBody = { progress_side_left_photo: resp.data.data.location }
          } else if (event == 3) {
            updateBody = { progress_side_right_photo: resp.data.data.location }
          } else if (event == 4) {
            updateBody = { progress_side_back_photo: resp.data.data.location }
          }
          // update to db
          axios.put(`crm/v1/assessment/first_assessment/${this.$route.query.xid}`, updateBody)
            .then(response => {
              this.loadingActive = false
              console.log("Photo updated", response);
              this.progressFrontPhotoPreview = null
              this.progressSideLeftPhotoPreview = null
              this.progressSideRightPhotoPreview = null
              this.progressSideBackPhotoPreview = null
              this.reloadData()
            }).catch(error => {
              console.error("Photo error", error);
            })
        }).catch(error => {
          this.loadingActive = false
          console.error("Photo error", error);
        })
    },
    // visbody
    onUploadImage() {
      this.loadingActive = true
      const formDataS3 = new FormData();
      formDataS3.append("file", this.visbodyPhotoPreview2);
      formDataS3.append("prefix", `ASSESMENT-${this.$route.query.id}`);
      axios.post("https://digmsix.paradigmfitnessindonesia.com/s3/storage/upload", formDataS3)
        .then(resp => {
          console.log("Photo uploaded to s3", resp);
          // update to db
          axios.put(`crm/v1/assessment/first_assessment/${this.$route.query.xid}`, { visbody_photo: resp.data.data.location })
            .then(response => {
              this.loadingActive = false
              console.log("Photo updated", response);
              this.visbodyPhotoPreview2 = null
              this.reloadData()
            }).catch(error => {
              console.error("Photo error", error);
            })
        }).catch(error => {
          this.loadingActive = false
          console.error("Photo error", error);
        })
    },
    reloadData() {
      axios.get(`crm/v1/assessment/first_assessment/${this.$route.query.xid}`).then((response) => {
        this.addData = response.data.data;
      })
    },
    fetchData() {
      axios.get(`crm/v1/assessment/first_assessment/${this.$route.query.xid}`).then((response) => {
        this.addData = response.data.data;
      })

      axios.get("fitness/v1/personal_training?status=active&sorting=name&sorting_type=asc").then((response) => {
        this.itemsPT = response.data.data.rows;
      })

      axios.get("crm/v1/assessment_category?page=&limit=").then((response) => {
        const data = response.data.data.rows;

        // filter timeframe expectation
        this.TIMEFRAME_EXPETATION = data.filter((item) => {
          return item.category_type == 'TIMEFRAME_EXPETATION';
        });

        // filter rating scale
        this.RATING_SCALE = data.filter((item) => {
          return item.category_type == 'RATING_SCALE';
        });

        // filter meal frequency
        this.MEAL_FREQUENCY = data.filter((item) => {
          return item.category_type == 'MEAL_FREQUENCY';
        });

        // filter snacking habits
        this.SNACKING_HABITS = data.filter((item) => {
          return item.category_type == 'SNACKING_HABITS';
        });

        // filter weekend intake
        this.WEEKEND_INTAKE = data.filter((item) => {
          return item.category_type == 'WEEKEND_INTAKE';
        });

        // filter eating out frequency
        this.EATING_OUT_FREQ = data.filter((item) => {
          return item.category_type == 'EATING_OUT_FREQ';
        });

        // filter willing to track
        this.WILLING_TO_TRACK = data.filter((item) => {
          return item.category_type == 'WILLING_TO_TRACK';
        });

        // filter ordinal scale
        this.ORDINAL_SCALE = data.filter((item) => {
          return item.category_type == 'ORDINAL_SCALE';
        });

        // filter work schedule
        this.WORK_SCHEDULE = data.filter((item) => {
          return item.category_type == 'WORK_SCHEDULE';
        });

        // filter consistency level
        this.CONSISTENCY_LEVEL = data.filter((item) => {
          return item.category_type == 'CONSISTENCY_LEVEL';
        });

        this.ONE_CHOICES = data.filter((item) => {
          return item.category_type == 'ONE_CHOICES';
        });
      })
    },
  },
  created() {
    this.fetchData();
    this.id_lead_member = this.$route.query.id;
    this.addData.member_id = this.$route.query.id;
    this.id_lead = this.$route.query.id_lead;
  },
};
</script>

<style>
.upload-container {
  max-width: 700px;
}

.upload-box {
  display: block;
  border: 2px dashed #cbd5e1;
  border-radius: 10px;
  padding: 40px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #f9fafb;
}

.upload-box:hover {
  border-color: #64748b;
  background: #f1f5f9;
}

.upload-content .icon {
  font-size: 40px;
  color: #94a3b8;
  margin-bottom: 10px;
}

.upload-content h5 {
  font-weight: 600;
  margin-bottom: 5px;
}

.upload-content p {
  color: #64748b;
  margin: 0;
}

.note {
  display: block;
  margin-top: 10px;
  color: #6b7280;
}


.required {
  color: red;
}

.radio-group {
  display: flex;
  gap: 20px;
  margin-top: 15px;
}

.radio-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}

/* hide default radio */
.radio-item input {
  display: none;
}

.circle {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 2px solid #cbd5e1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #64748b;
  transition: all 0.3s ease;
}

/* selected */
.radio-item input:checked+.circle {
  background: linear-gradient(135deg, #4f6df5, #3b5bdb);
  color: white;
  border: none;
}

/* label text */
.radio-item small {
  margin-top: 8px;
  color: #64748b;
}

.nutrition-note {
  max-width: 900px;
  color: #374151;
  font-family: 'Segoe UI', sans-serif;
}

.title-main {
  letter-spacing: 1px;
}

.section {
  margin-top: 30px;
}

.section-title {
  font-weight: 700;
  text-transform: uppercase;
  margin-bottom: 10px;
}

ol {
  padding-left: 20px;
  margin-bottom: 10px;
}

ol li {
  margin-bottom: 6px;
  letter-spacing: 0.5px;
}

.note {
  margin-top: 10px;
  color: #4b5563;
}

.card-custom {
  max-width: 800px;
  margin: auto;
  border-radius: 16px;
}

.section-title {
  font-weight: 700;
  letter-spacing: 1px;
}

.note {
  font-style: italic;
  color: #6c757d;
}

</style>
